<!-- <button class="carousel-btn prev-btn" (click)="prev()"><i class="fa-solid fa-chevron-left"></i></button>
    <button class="carousel-btn next-btn" (click)="next()"><i class="fa-solid fa-chevron-right"></i></button>
<div class="maintesti">
    <main id="carousel" [style.--position]="position" [style.--abs]="absPosition">
        <div class="item" [class.active]="position === 1">
            <div class="image">
                <img src="https://eureka2022.s3.ap-south-1.amazonaws.com/testimonials/2new.png" alt="">
            </div>
            <div class="name">
                <h2>MyWays</h2>
            </div>
            <div class="testi">
                <p>Registering for Eureka was one of the best decisions we ever took! We were invited to offline events, pitch sessions and were also connected with diverse industry leaders to help improve our idea. Appreciate all the good work initiated by E-Cell team of IIT Bombay!</p>
            </div>
        </div>
        <div class="item" [class.active]="position === 2">
            <div class="image">
                <img src="https://eureka2022.s3.ap-south-1.amazonaws.com/testimonials/curomatesLogoWhite.png" alt="">
            </div>
            <div class="name">
                <h2>Curomates</h2>
            </div>
            <div class="testi">
                <p>Eureka by E-Cell, provides the framework required to shape your idea into a real world startup and a platform to network. Mentors allotted provided us with useful suggestions during our connect sessions. Also, the offline networking events were well organized.</p>
            </div>
        </div>
        <div class="item" [class.active]="position === 3">
            <div class="image">
                <img src="https://eureka2022.s3.ap-south-1.amazonaws.com/testimonials/unnamed.png" alt="">
            </div>
            <div class="name">
                <h2>BlisCare</h2>
            </div>
            <div class="testi">
                <p>During the different stages of the event, we went through a lot of learnings and mentorships. It also provides opportunity to network with very resourceful individuals. Being a winner, we were taken to Dubai-Expo-2020, which was one of the great opportunities we received.</p>
            </div>
        </div>
        <div class="item" [class.active]="position === 4">
            <div class="image">
                <img src="https://eureka2022.s3.ap-south-1.amazonaws.com/testimonials/Twitter%20Header%20Photo.png" alt="">
            </div>
            <div class="name">
                <h2>DocEye</h2>
            </div>
            <div class="testi">
                <p>Post Eureka! 21, we were privileged to start our discussion with the main sponsor of the Fintech Track (SBI General Insurance). This signifies that Eureka! is not merely an entrepreneurial event but is a holistic startup ecosystem which nurtures the deserving ideas.</p>
            </div>
        </div>
        <div class="item" [class.active]="position === 5">
            <div class="image">
                <img src="https://eureka2022.s3.ap-south-1.amazonaws.com/testimonials/AI-Genex%20logo%20tagline%20white%20BG.jpg" alt="">
            </div>
            <div class="name">
                <h2>AI-Genix</h2>
            </div>
            <div class="testi">
                <p>After we identified a real world social problem, Eureka! indeed played a significant role in our entrepreneurial journey. We got an access to world-class mentors, the much-needed customer connections, and the opportunity to present our project to domestic and foreign investors.</p>
            </div>
        </div>
      </main>
</div> -->

<div id="testimonial-carousel" class="carousel slide" data-bs-ride="carousel">
  <div class="carousel-inner">
    <div class="carousel-item active">
      <div class="carousel_inner">
        <div class="team">
          <img
            src="https://eureka2022.s3.ap-south-1.amazonaws.com/testimonials/2new.png"
            alt="Logo"
          />
          <h3>MyWays</h3>
        </div>
        <div>
          <p>
            Registering for Eureka! was one of the best decisions we ever took!
            We were invited to offline events, pitch sessions and were also
            connected with diverse industry leaders to help improve our idea.
            Appreciate all the good work initiated by E-Cell team of IIT Bombay!
          </p>
        </div>
      </div>
    </div>
    <div class="carousel-item">
      <div class="carousel_inner">
        <div class="team">
          <img
            src="https://eureka2022.s3.ap-south-1.amazonaws.com/testimonials/curomatesLogoWhite.png"
            alt="Logo"
          />
          <h3>Curomates</h3>
        </div>
        <div>
          <p>
            Eureka! by E-Cell, provides the framework required to shape your
            idea into a real world startup and a platform to network. Mentors
            allotted provided us with useful suggestions during our connect
            sessions. Also, the offline networking events were well organized.
          </p>
        </div>
      </div>
    </div>
    <div class="carousel-item">
      <div class="carousel_inner">
        <div class="team">
          <img
            src="https://eureka2022.s3.ap-south-1.amazonaws.com/testimonials/unnamed.png"
            alt="Logo"
          />
          <h3>BlisCare</h3>
        </div>
        <div>
          <p>
            During the different stages of the event, we went through a lot of
            learnings and mentorships. It also provides opportunity to network
            with very resourceful individuals. Being a winner, we were taken to
            Dubai-Expo-2020, which was one of the great opportunities we
            received.
          </p>
        </div>
      </div>
    </div>
    <div class="carousel-item">
      <div class="carousel_inner">
        <div class="team">
          <img
            src="https://eureka2022.s3.ap-south-1.amazonaws.com/testimonials/Twitter%20Header%20Photo.png"
            alt="Logo"
          />
          <h3>DocEye</h3>
        </div>
        <div>
          <p>
            Post Eureka! 21, we were privileged to start our discussion with the
            main sponsor of the Fintech Track (SBI General Insurance). This
            signifies that Eureka! is not merely an entrepreneurial event but is
            a holistic startup ecosystem which nurtures the deserving ideas.
          </p>
        </div>
      </div>
    </div>
    <div class="carousel-item">
      <div class="carousel_inner">
        <div class="team">
          <img
            src="https://eureka2022.s3.ap-south-1.amazonaws.com/testimonials/AI-Genex%20logo%20tagline%20white%20BG.jpg"
            alt="Logo"
          />
          <h3>AI-Genix</h3>
        </div>
        <div>
          <p>
            After we identified a real world social problem, Eureka! indeed
            played a significant role in our entrepreneurial journey. We got an
            access to world-class mentors, the much-needed customer connections,
            and the opportunity to present our project to domestic and foreign
            investors.
          </p>
        </div>
      </div>
    </div>
  </div>
  <button
    class="carousel-control-prev"
    type="button"
    data-bs-target="#testimonial-carousel"
    data-bs-slide="prev"
  >
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="filler"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button
    class="carousel-control-next"
    type="button"
    data-bs-target="#testimonial-carousel"
    data-bs-slide="next"
  >
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="filler"></span>
    <span class="visually-hidden">Next</span>
  </button>
</div>
